import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { MenuIcon, ShoppingBagIcon, XIcon } from "lucide-react";
import { product } from "../data/product";
const links = [{
  href: "#bundle",
  label: "Il pacchetto"
}, {
  href: "#dentro",
  label: "Cosa trovi all'interno"
}, {
  href: "#bonus",
  label: "I 5 bonus"
}, {
  href: "#faq",
  label: "Domande frequenti"
}];
export function Header() {
  const [open, setOpen] = useState(false);
  return <header className="sticky top-0 z-40 border-b border-line/60 bg-white" data-id="element-98" data-mp="2wl8n3dmrd6mg">
      <div className="mx-auto flex h-14 max-w-6xl items-center justify-between px-4 sm:h-16 sm:px-6" data-id="element-99" data-mp="2wj5pa7fd6976">
        <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-label={open ? "Chiudi menu" : "Apri menu"} className="-ml-2 rounded-full p-2 text-wine focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-rose" data-id="element-100" data-mp="31e1ru1i88eyj">
          {open ? <XIcon className="h-6 w-6" strokeWidth={1.5} data-id="element-101" data-mp="2wkul8qn73d4p" /> : <MenuIcon className="h-6 w-6" strokeWidth={1.5} data-id="element-102" data-mp="2wlmbrn1xqko4" />}
        </button>
        <a href="#top" className="font-serif text-lg font-semibold tracking-tight text-wine sm:text-xl" data-id="element-103" data-mp="2rli0cbfvwg4r">
          {product.name}
        </a>
        <a href="#acquista" aria-label="Vai alla sezione di acquisto" className="-mr-2 rounded-full p-2 text-wine focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-rose" data-id="element-104" data-mp="2mmwyk7kzhoe7">
          <ShoppingBagIcon className="h-6 w-6" strokeWidth={1.5} data-id="element-105" data-mp="3ac9avgblyckq" />
        </a>
      </div>
      <AnimatePresence data-id="element-106" data-mp="3aelq3lpze8u3">
        {open && <motion.nav initial={{
        opacity: 0,
        y: -6
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -6
      }} transition={{
        duration: 0.18,
        ease: [0.23, 1, 0.32, 1]
      }} className="absolute inset-x-0 top-full border-b border-line bg-white shadow-lg" aria-label="Navigazione principale" data-id="element-107" data-mp="35khg0tlf5kos">
            <ul className="mx-auto max-w-6xl px-4 py-2 sm:px-6" data-id="element-108" data-mp="1rdtcbws5s14w">
              {links.map(l => <li key={l.href} data-id="element-109" data-mp="1wd62aqebtobp">
                  <a href={l.href} onClick={() => setOpen(false)} className="block border-b border-line/60 py-3.5 font-medium text-wine last:border-0" data-id="element-110" data-mp="1wbcw1c7ml648">
                    {l.label}
                  </a>
                </li>)}
            </ul>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}